import s from './payment-history.module.scss'
import { PageTemplate } from '@shared/ui/page-template'
import { PayoutsTable } from '@widgets/settings/ui/payouts-table/payouts-table'
import { Tooltip } from 'react-tooltip'

export const PaymentHistory = () => {
	return (
		<PageTemplate title='История выплат'>
			<div className={s.wrapper}>
				<PayoutsTable />
				<Tooltip
					id="tooltip-canceled-payout"
					content="Обратиться в поддержку"
				/>
			</div>
		</PageTemplate>
	)
}
